/**
 * Contenido del sitio (modo estático).
 * Centralizado aquí para editar textos con facilidad y, más adelante,
 * migrar las secciones dinámicas (Recursos, Contenido, Testimonios) a Supabase.
 */

export const brand = {
  name: 'Emilia Hidalgo',
  tagline: 'Personas que avanzan. Equipos que crecen.',
  domain: 'emiliahidalgo.com',
  instagram: 'https://www.instagram.com/emilia.h.coach/',
  linkedin: 'https://www.linkedin.com/in/emilia-hidalgo-sep%C3%BAlveda-96283bb4/',
  whatsappNumber: '56979873383',
  whatsappMessage: '¡Hola Emilia! Vi tu página web y me gustaría conversar contigo.',
  email: 'hola@emiliahidalgo.com',
}

/** Enlace a WhatsApp con el mensaje de saludo prellenado. */
export const whatsappUrl = `https://wa.me/${brand.whatsappNumber}?text=${encodeURIComponent(
  brand.whatsappMessage,
)}`

export type NavItem = { label: string; href: string }

export const navItems: NavItem[] = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Sobre mí', href: '#sobre-mi' },
  { label: 'Charlas y Talleres', href: '#charlas' },
  { label: 'Empresas', href: '#empresas' },
  { label: 'Recursos', href: '#recursos' },
  { label: 'Contenido', href: '#contenido' },
  { label: 'Contacto', href: '#contacto' },
]

export type Pillar = {
  key: string
  title: string
  tags: string[]
  text: string
  cta: string
  href: string
}

export const pillars: Pillar[] = [
  {
    key: 'personal',
    title: 'Crecimiento personal y profesional',
    tags: [
      'Metas',
      'Hábitos',
      'Motivación',
      'Autoconocimiento',
      'Desarrollo profesional',
      'Toma de decisiones',
    ],
    text: 'Herramientas para pasar de querer un cambio a comenzar a construirlo.',
    cta: 'Quiero avanzar',
    href: '#charlas',
  },
  {
    key: 'empleabilidad',
    title: 'Empleabilidad y carrera',
    tags: [
      'Búsqueda laboral',
      'CV',
      'Entrevistas',
      'Desarrollo de carrera',
      'Habilidades laborales',
      'Crecimiento profesional',
    ],
    text: 'Encontrar trabajo es importante. Construir una carrera que tenga sentido para ti lo es aún más.',
    cta: 'Potencia tu carrera',
    href: '#recursos',
  },
  {
    key: 'equipos',
    title: 'Equipos y organizaciones',
    tags: [
      'Liderazgo',
      'Motivación',
      'Comunicación',
      'Clima laboral',
      'Trabajo en equipo',
      'Desarrollo de personas',
    ],
    text: 'Equipos más conectados, líderes más conscientes y organizaciones donde las personas puedan desarrollarse.',
    cta: 'Soluciones para empresas',
    href: '#empresas',
  },
]

export type Taller = { title: string; text: string }

export const talleres: Taller[] = [
  {
    title: 'Motivación y propósito',
    text: 'Cómo transformar objetivos en acciones sostenibles.',
  },
  {
    title: 'Liderazgo y desarrollo de equipos',
    text: 'Herramientas para liderar personas, generar compromiso y favorecer el crecimiento.',
  },
  {
    title: 'Comunicación y relaciones laborales',
    text: 'Construir ambientes donde las personas puedan comunicarse, colaborar y resolver diferencias de manera saludable.',
  },
  {
    title: 'Empleabilidad y desarrollo profesional',
    text: 'Herramientas para buscar oportunidades, enfrentar procesos de selección y desarrollar una carrera.',
  },
  {
    title: 'Metas y crecimiento personal',
    text: 'Del “quiero hacerlo” al “estoy trabajando para conseguirlo”.',
  },
]

export const empresaServicios: string[] = [
  'Charlas corporativas',
  'Talleres y capacitaciones',
  'Programas de desarrollo',
  'Actividades para equipos',
  'Experiencias personalizadas',
]

export type Recurso = { title: string; text: string }

export const recursos: Recurso[] = [
  { title: 'Plantilla para definir objetivos', text: 'Ordena lo que quieres lograr y por dónde empezar.' },
  { title: 'Checklist para una entrevista laboral', text: 'Prepárate con claridad y llega con seguridad.' },
  { title: 'Guía para mejorar el CV', text: 'Cuenta tu experiencia de forma que se entienda tu valor.' },
  { title: 'Ejercicio para identificar fortalezas', text: 'Reconoce en qué destacas y cómo potenciarlo.' },
  { title: 'Guía de planificación de metas', text: 'Del deseo al plan: pasos concretos y sostenibles.' },
  { title: 'Herramientas para líderes', text: 'Recursos prácticos para acompañar a tu equipo.' },
]

export const categoriasContenido: string[] = [
  'Psicología',
  'Trabajo',
  'Liderazgo',
  'Empleabilidad',
  'Equipos',
  'Desarrollo personal',
]
